"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsultaParque = getConsultaParque;
exports.getDatosClienteM = getDatosClienteM;
exports.getDatosClientes = getDatosClientes;

var _effects = require("redux-saga/effects");

var _gerenciatdAdabyronLegado = require("@bit/gerenciatd.adabyron-legado.client");

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _clientCCLI = require("../Reducer/clientCCLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const contextStore = state => state.context.data;

function* getDatosClientes() {
  const context = yield (0, _effects.select)(contextStore);
  const obj = [{}, context];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado.consultaDatosClienteG, ...obj);
    yield (0, _effects.put)(_clientCCLI.actions.getDatosClienteGSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getDatosClientes',
      context,
      filePath: 'legavid/reduxSagaClientCCLI'
    });
    sonda.errorMessage({
      info: 'Error getDatosClientes',
      error
    });
    yield (0, _effects.put)(_clientCCLI.actions.getDatosClienteGFail());
  }
}

function* getDatosClienteM() {
  // const context = clientAction.data
  const context = yield (0, _effects.select)(contextStore);
  const obj = [context];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado.consultaDatosClienteM, ...obj);
    yield (0, _effects.put)(_clientCCLI.actions.getDatosClienteMSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getDatosClienteM',
      context,
      filePath: 'legavid/reduxSagaClientCCLI'
    });
    sonda.errorMessage({
      info: 'Error datosClienteM',
      error
    });
    yield (0, _effects.put)(_clientCCLI.actions.getDatosClienteMFail());
  }
}

function* getConsultaParque(clientAction) {
  const args = clientAction.payload;
  const context = clientAction.data;
  const obj = [args, context];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado.consultaParque, ...obj);
    yield (0, _effects.put)(_clientCCLI.actions.getConsultaParqueSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getConsultaParque',
      context,
      filePath: 'legavid/reduxSagaClientCCLI'
    });
    sonda.errorMessage({
      info: 'Error consultaParque',
      error
    });
    yield (0, _effects.put)(_clientCCLI.actions.getConsultaParqueFail());
  }
}

//# sourceMappingURL=clientCCLI.js.map